export default __webpack_public_path__ + "static/media/enterprise.dd226682.svg";